import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import Cookies from 'js-cookie';
import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { setAlert } from 'src/layouts/main/MainLayoutSlice';
import { getRegionBySlug, resetPassword } from 'src/pages/CareerHistory/CareerHistorySlice';
import { EMAIL_REGEXP } from 'src/utils';
import * as Yup from 'yup';
import AuthWrapper from './AuthWrapper';
import FormTextField from './FormTextField';
import TextFIeldComponent from './TextField/TextFieldComponent';

const ResetPassword = () => {
  const validationSchema = Yup.object().shape({
    password: Yup.string().required('Password is required'),
    confirmpassword: Yup.string().required('Confirm Password is required'),
  });
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    getValues,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      password: '',
      confirmpassword: '',
    },
  });

  const navigate = useNavigate();
  const params = useParams();
  const isRegion = !!params?.rg_name;
  const collegeDetails = useSelector((state) => state.mainLayout.collegeDetails);
  const collegeId = collegeDetails?._id;
  const [isPasswordHidden, setIsPasswordHidden] = useState(true);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const { cg_name, rg_name } = useParams();

  useEffect(() => {
    if (rg_name) {
      Cookies.set('url-slug', rg_name);
    }
  }, [rg_name]);

  useEffect(() => {
    dispatch(getRegionBySlug(rg_name));
  }, [rg_name, dispatch]);
  const onSubmit = (values) => {
    setIsLoading(true);
    // dispatch(resetPassword(values))
    //   .then((res) => {
    //     const data = res?.payload?.data;
    //     console.log('res----> ', res);
    //     if (data?.success) {
    //       dispatch(
    //         setAlert({
    //           open: true,
    //           isSuccess: true,
    //           type: 'success',
    //           msg: get(res, 'payload.data.message')
    //             ? get(res, 'payload.data.message')
    //             : 'successfully sent reset code',
    //         })
    //       );
    //       reset();
    //     } else {
    //       const errorMessage =
    //         get(res, 'payload.response.data.message') ||
    //         'Something Went Wrong, Please try again later';
    //       dispatch(
    //         setAlert({
    //           open: true,
    //           msg: errorMessage,
    //         })
    //       );
    //     }
    //   })
    //   .finally(() => setIsLoading(false));
  };
  const buttonColor = collegeDetails ? collegeDetails?.region?.button?.bgColor : '';
  const buttonFontColor = collegeDetails ? collegeDetails?.region?.button?.color : '';
  const fontColor = collegeDetails ? collegeDetails?.region?.fontColor : '';
  const bgImage = collegeDetails ? collegeDetails?.region?.bgImage : '';
  return (
    <AuthWrapper title="Forgot-Password">
      <Box
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '100vh',
          paddingTop: 3,
        }}
        className="page-content-wrapper"
      >
        <Container>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography
              sx={{ fontSize: '32px !important', mb: 2, mt: { lg: 2, sm: 0 }, color: fontColor }}
            >
              <b>Change Your Password</b>
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: {
                  xs: '100%', // full width on extra-small screens
                  sm: 600, // 500px on small screens
                  md: 600, // 600px on medium screens
                  lg: 700, // 700px on large screens
                  xl: 800, // 800px on extra-large screens
                },
                backgroundColor: 'white',
                py: 4,
                borderRadius: '8px',
              }}
            >
              <form onSubmit={handleSubmit(onSubmit)}>
                <Typography mb={1} variant="subtitle2">
                  Password*
                </Typography>
                <Stack mb={2} direction="row" alignItems="center" spacing={2}>
                  <TextFIeldComponent
                    name="password"
                    placeholder="Enter password"
                    control={control}
                    {...register('password')}
                    className="input-text-field postcode"
                    type={isPasswordHidden ? 'password' : 'text'}
                  />
                  <Button
                    sx={{
                      borderRadius: '8px',
                      color: buttonFontColor || 'black',
                    }}
                    onClick={() => setIsPasswordHidden((prevValue) => !prevValue)}
                  >
                    <Typography mb={1} variant="subtitle2">
                      {!isPasswordHidden ? 'Hide' : 'Show'} Password
                    </Typography>
                  </Button>
                </Stack>
                <Typography mb={1} variant="subtitle2">
                  Confirm Password*
                </Typography>
                <Stack mb={2} direction="row" alignItems="center" spacing={2}>
                  <TextFIeldComponent
                    name="confirmpassword"
                    placeholder="Confirm Password"
                    control={control}
                    {...register('confirmpassword')}
                    className="input-text-field postcode"
                    type={isPasswordHidden ? 'confirmpassword' : 'text'}
                  />
                  <Button
                    sx={{
                      borderRadius: '8px',
                      color: buttonFontColor || 'black',
                    }}
                    onClick={() => setIsPasswordHidden((prevValue) => !prevValue)}
                  >
                    <Typography mb={1} variant="subtitle2">
                      {!isPasswordHidden ? 'Hide' : 'Show'} Password
                    </Typography>
                  </Button>
                </Stack>
                <LoadingButton
                  sx={{
                    backgroundColor: (theme) =>
                      `${buttonColor || theme.palette.primary.main} !important`,
                    borderRadius: '8px',
                    color: buttonFontColor || 'white',
                    // width: '80%',
                    p: 2,
                    my: 1,
                  }}
                  fullWidth
                  type="submit"
                  loading={isLoading}
                  // onClick={(e) => showCareerDetailsPopup(item.id, e)}
                >
                  Reset Password
                </LoadingButton>
              </form>
            </Box>
          </Box>
        </Container>
      </Box>
    </AuthWrapper>
  );
};

export default ResetPassword;
